<template>
  <v-app>
    <vertical-nav-menu :title="agencyName" :is-drawer-open.sync="isDrawerOpen"></vertical-nav-menu>

    <v-app-bar app flat absolute color="transparent">
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <!-- Left Content -->
          <v-app-bar-nav-icon class="me-2" @click="isDrawerOpen = !isDrawerOpen"></v-app-bar-nav-icon>

          <!-- Logo -->
          <router-link v-if="!isDrawerOpen" to="/" class="d-flex align-center text-decoration-none">
            <v-img
              :src="(user && user.organization && user.organization.company_logo_image) || brandLogo"
              max-height="100px"
              max-width="100px"
              alt="logo"
              contain
              eager
              class="app-logo me-3"
            ></v-img>
            <v-slide-x-transition>
              <h3 class="app-title text--primary font-weight-bold">{{ agencyName }}</h3>
            </v-slide-x-transition>
          </router-link>

          <v-spacer></v-spacer>

          <currency-switcher></currency-switcher>

          <language-switcher></language-switcher>
          <!-- <theme-switcher></theme-switcher> -->
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>

    <layout-footer></layout-footer>
  </v-app>
</template>

<script>
import { computed, onMounted, reactive, ref, watch } from "@vue/composition-api";
import { mdiMagnify, mdiBellOutline, mdiGithub } from "@mdi/js";
import VerticalNavMenu from "./vertical-nav-menu/VerticalNavMenu.vue";
import ThemeSwitcher from "./ThemeSwitcher.vue";
import AppBarUserMenu from "./AppBarUserMenu.vue";
import i18n from "@/plugins/i18n";
import LayoutFooter from "./LayoutFooter.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import CurrencySwitcher from "./CurrencySwitcher.vue";

export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
    LayoutFooter,
    LanguageSwitcher,
    CurrencySwitcher,
  },
  setup(props, { root }) {
    const brand = computed(() => root.$store.getters.brand);
    const brandLogo = computed(() => brand.value?.logo || require("@/assets/images/logo.png"));
    const user = computed(() => root.$store.getters.user);
    const agencyName = computed(() => root.$store.getters.user?.organization?.name || "Unknown Agency");
    const menuLanguage = ref(false);
    const languages = reactive([
      {
        language: "en",
        title: "English",
        image: require("@/assets/images/languages/en.png"),
      },
      {
        language: "th",
        title: "ไทย",
        image: require("@/assets/images/languages/th.png"),
      },
    ]);

    const flagImage = computed(() => {
      if (i18n.locale === "en") return require("@/assets/images/languages/en.png");
      if (i18n.locale === "th") return require("@/assets/images/languages/th.png");

      // default
      return require("@/assets/images/languages/en.png");
    });

    const changeLocale = (locale) => {
      i18n.locale = locale;
      root.$cookies.set("locale", locale, "14d");
    };

    const isDrawerOpen = ref(null);
    const searchInput = ref(null);
    const searchItems = reactive(
      root.$router.options.routes
        .filter((each) => each.meta && each.meta.searchLabel)
        .sort((a, b) => {
          const fa = a.meta.searchLabel.toLowerCase();
          const fb = b.meta.searchLabel.toLowerCase();
          if (fa < fb) return -1;
          if (fa > fb) return 1;

          return 0;
        }),
    );

    const customFilter = (item, queryText) => {
      const searchText = queryText.toLowerCase();
      const keywords = item.meta.keywords.map((each) => each.toLowerCase());

      return (
        keywords.find((each) => each.indexOf(searchText) > -1) ||
        item.meta.searchLabel.toLowerCase().indexOf(searchText) > -1
      );
    };

    onMounted(() => {
      i18n.locale = root.$cookies.get("locale") || "en";
    });

    watch(searchInput, (value) => {
      if (!!value && root.$route.name !== value) root.$router.push({ name: value });
    });

    return {
      brandLogo,
      user,
      agencyName,
      menuLanguage,
      languages,
      flagImage,
      changeLocale,
      isDrawerOpen,
      searchInput,
      searchItems,
      customFilter,
      icons: {
        mdiMagnify,
        mdiBellOutline,
        mdiGithub,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}
</style>
